module.exports = __webpack_public_path__ + "img/svg/background-error-stain1.2c5a92a0ca0587231553252fb79b07ad.svg";